import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-accent-700 md:text-sm">
              <span className="h-px w-6 bg-accent-500" />
              常见问题
            </div>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              关于糖豆视频，你可能想问
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              从观看、关注到内容审核与未成年人保护，这里整理了大家最关心的几个问题。
            </p>

            <div className="mt-6 flex items-center gap-3 rounded-xl border border-background-200 bg-background-100 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-customer-service-2-line text-lg" />
              </span>
              <div>
                <p className="font-heading text-sm font-bold text-foreground-950">还有别的问题？</p>
                <p className="text-xs text-foreground-500">站内客服 7×24 小时在线为你解答</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="flex flex-col gap-3">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <li key={item.q}>
                    <Reveal delay={(index % 6) * 50}>
                      <div
                        className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                          isOpen ? 'border-primary-300' : 'border-background-200'
                        }`}
                      >
                        <button
                          type="button"
                          onClick={() => setOpenIndex(isOpen ? null : index)}
                          className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                        >
                          <span className="flex items-start gap-3">
                            <span
                              className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                                isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                              }`}
                            >
                              {index + 1}
                            </span>
                            <span className="font-heading text-base font-bold text-foreground-950">{item.q}</span>
                          </span>
                          <i
                            className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                              isOpen ? 'ri-subtract-line rotate-180 text-primary-600' : 'ri-add-line'
                            }`}
                          />
                        </button>
                        <div
                          className={`grid transition-all duration-300 ease-out ${
                            isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                          }`}
                        >
                          <div className="overflow-hidden">
                            <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                          </div>
                        </div>
                      </div>
                    </Reveal>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}